import React from "react";
import SimpleModal from "../../Examples/Modals";

export default function SearchWork() {
  return (
    <>
      <SimpleModal />
    </>
  );
}
